import { render } from "./LeaseUserAdmin2.vue?vue&type=template&id=083a3848"
import script from "./LeaseUserAdmin2.vue?vue&type=script&lang=js"
export * from "./LeaseUserAdmin2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__